import { Injectable } from '@angular/core';
import { BaseBackend } from '@shared/apis/servers/base-backend';
import { Observable } from 'rxjs';
import { HttpHeaders, HttpRequest } from '@angular/common/http';
import { timeout } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class InquiryBackendServer extends BaseBackend {
  createInquiry(data): Observable<any> {
    return this.post('/inquiry', data);
  }

  getInquiryListWithCaseNo(data): Observable<any> {
    return this.get(`/inquiry/${ data }`);
  }

  getInquiryTargetEmails(partnerOrganization, params?): Observable<any> {
    return this.get(`/inquiry/inquiry-target-emails/${ partnerOrganization }`, { params });
  }

  saveComment(data): Observable<any> {
    return this.patch(`/inquiry/${ data.escalationNo }`, data);
  }

  serverFileUpload(escalationNo, formData): Observable<any> {
    const headers = new HttpHeaders();
    headers.append('Content-Type', 'multipart/form-data');
    headers.append('Accept', 'application/json');

    const options = {
      headers,
      reportProgress: true,
    };

    const uploadReq = new HttpRequest('PATCH', `${ this.backend }/inquiry/${ escalationNo }/attachments/file`, formData, options);

    return this.http.request(uploadReq).pipe(timeout(500000));
  }

  deleteFile(params: any): Observable<any> {
    const { escalationNo } = params;
    return this.delete(`/inquiry/${ escalationNo }/file`, { params });
  }

  changeStatus(data): Observable<any> {
    return this.patch(`/inquiry/${ data.escalationNo }/status`, data);
  }

  getInquiries(builder): Observable<any> {
    return this.get('/inquiry', { params: builder });
  }

  getInquiryInfo(data): Observable<any> {
    return this.get(`/inquiry/${ data }/info`);
  }

  exportInquiryList(builder): Observable<any> {
    return this.post('/inquiry/export', builder);
  }

  getInquiryRecipientsEmails(): Observable<any> {
    return this.get('/inquiry/inquiry-emails/recipients', {});
  }

  getInquiryEscalateEmails(): Observable<any> {
    return this.get('/inquiry/inquiry-emails/escalate-to', {});
  }

  getInquirySummary(): Observable<any> {
    return this.get('/inquiry/inquiry-emails/summary', {});
  }
}
